import { css } from 'styled-components';
import { getSpacing, SpacingName } from '../../theme';
export const loading = _ref => {
  let {
    theme
  } = _ref;
  return css(["", " position:relative;display:flex;align-items:center;justify-content:center;"], getSpacing.padding(theme, SpacingName.SMALL));
};
export const error = () => css(["width:100%;"]);
//# sourceMappingURL=AsyncLoading.style.js.map